import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex items-center text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-2"
}

import { ref, watch, onMounted } from 'vue';
import { WhatsappCodeService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { useUiStore } from '@/stores';
import { NumberModel, WhatsappCodeServiceGetNumbersParams } from '@/types';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';
import WhatsappCodeNumberListItem from './components/WhatsappCodeNumberListItem.vue';

const perPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsappCodeListPage',
  setup(__props) {

const numbers = ref<NumberModel[]>([]);
const count = ref(0);
const currentPage = ref(1);
const search = ref('');

const uiStore = useUiStore();
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getParams = (): WhatsappCodeServiceGetNumbersParams => ({
    page: currentPage.value,
    per_page: perPage,
    search: search.value || undefined,
});

const fetchNumbers = async () => {
    setLoading(true);
    try {
        const { data, headers } = await WhatsappCodeService.getNumbers({
            params: getParams(),
        });
        numbers.value = data;
        count.value = parseInt(headers['x-pagination-count']) || data.length;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

watch([currentPage], () => {
    fetchNumbers();
});

watch([search], () => {
    if (currentPage.value === 1) fetchNumbers();
    else currentPage.value = 1;
});

onMounted(() => {
    fetchNumbers();
});

return (_ctx: any,_cache: any) => {
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiListSearch = _resolveComponent("UiListSearch")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(SVGWhatsApp, { class: "mr-1.5 h-6 w-6 text-[#25D366]" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('whatsappCode.title')), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UiPanel, {
        class: "flex px-4 py-2",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UiListSearch, {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            placeholder: _ctx.$t('whatsappCode.searchPlaceholder'),
            class: "flex-1"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }),
      (numbers.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numbers.value, (number) => {
              return (_openBlock(), _createBlock(WhatsappCodeNumberListItem, {
                key: number.id,
                "model-value": number
              }, null, 8, ["model-value"]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_UiPanel, {
            key: 1,
            class: "flex items-center justify-center py-8 text-gray-500"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.messages.noRecordsFound')), 1)
            ]),
            _: 1
          })),
      (numbers.value.length)
        ? (_openBlock(), _createBlock(_component_UiPagination, {
            key: 2,
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
            count: count.value,
            perPage: perPage
          }, null, 8, ["modelValue", "count"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})